import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

interface Props {
  city: string;
  count: number;
}

export function CityAgencyCard({ city, count }: Props) {
  return (
    <Link
      to={`/agencies?city=${encodeURIComponent(city)}`}
      className="snap-start shrink-0 w-[240px] h-[110px] p-3 rounded-lg border bg-card hover:shadow-md transition-all relative overflow-hidden"
      style={{
        backgroundImage:
          'linear-gradient(135deg, hsl(var(--muted) / 0.3) 0%, transparent 60%), repeating-linear-gradient(45deg, hsl(var(--border) / 0.4) 0 1px, transparent 1px 14px), repeating-linear-gradient(-45deg, hsl(var(--border) / 0.4) 0 1px, transparent 1px 14px)',
      }}
    >
      <div className="relative">
        <h3 className="font-bold text-sm">{city}</h3>
        <p className="text-xs text-muted-foreground mt-1">{count} {count === 1 ? 'Agency' : 'Agencies'}</p>
        <span className="inline-flex items-center gap-1 text-xs text-primary font-medium mt-3">
          View Trend <ArrowUpRight className="h-3 w-3" />
        </span>
      </div>
    </Link>
  );
}
